export default function isAxiosError(error) {
    return error != null && "response" in error;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils/isAxiosError.ts